<template>
  <div>
    <a-form :form="form" labelAlign="left">
      <a-row :gutter="layoutConfig.gutter">
        <template v-for="(item, index) in filterList">
          <a-col :span="layoutConfig.span" :key="item.key" :style="{ display: index < count ? 'block' : 'none' }">
            <a-form-item :label="item.label" :languageKey="item.languageKey" :labelCol="layoutConfig.labelCol" :wrapperCol="layoutConfig.wrapperCol">
              <!-- 默认输入框 -->
              <template v-if="item.type === FormTypes.input">
                <a-input v-decorator="[item.key]" v-model.trim="value[item.key]" :placeholder="setPlaceholder(item)" />
              </template>
              <!-- 数字输入框 -->
              <template v-else-if="item.type === FormTypes.inputNumber">
                <a-input-number v-decorator="[item.key]" v-model.trim="value[item.key]" :placeholder="setPlaceholder(item)" style="width: 100%" />
              </template>
              <!-- 下拉选择框 -->
              <template v-else-if="item.type === FormTypes.select">
                <a-select v-decorator="[item.key]"
                          v-model="value[item.key]"
                          :placeholder="setPlaceholder(item)"
                          :mode="item.isMultiple? 'multiple' : 'default'"
                          :maxTagCount="item.maxTagCount || layoutConfig.maxTagCount"
                          allowClear
                          showSearch
                          option-label-prop="label"
                          option-filter-prop="children"
                          :filter-option="filterOption">
                  <template v-for="k in optionsData[item.optionKey] || optionsData[item.key]">
                    <a-select-option :key="k.value" :value="k.value" :label="k.label || k.text">
                      {{ k.text || k.label }}
                    </a-select-option>
                  </template>
                </a-select>
              </template>
              <!-- 时间范围 -->
              <template v-else-if="item.type === FormTypes.dateRange">
                <a-range-picker v-decorator="[item.key]"
                                :ranges="ranges"
                                inputReadOnly
                                style="width: 100%;"
                                @change="(momentArr, strArr) => onRangesDateChange(momentArr, strArr, item)" />
              </template>
              <!-- 日期选择 -->
              <template v-else-if="item.type === FormTypes.date">
                <a-date-picker v-decorator="[item.key]"
                               inputReadOnly
                               style="width: 100%;"
                               @change="(momentArr, strArr) => onDateChange(momentArr, strArr, item)" />
              </template>
              <!-- 默认输入框 -->
              <template v-else>
                <a-input v-decorator="[item.key]" v-model.trim="value[item.key]" :placeholder="setPlaceholder(item)" />
              </template>
            </a-form-item>
          </a-col>
        </template>
        <!-- 展开、折叠，查询条件数量小于折叠数量则不展示 -->
        <a-col :span="2" v-if="filterList.length !== layoutConfig.foldCount">
          <a style="line-height: 38px" @click="expand = !expand">
            <mtcLangPopover :text="expand? 'tip.up': 'tip.down'" />
            <a-icon :type="expand ? 'up' : 'down'" />
          </a>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import { FormTypes } from '@/utils/JEditableTableUtil'

export default {
  name: 'MtcSearch',
  props: {
    // 查询条件值
    value: {
      type: Object,
      require: true,
      default: () => {
      }
    },
    // 查询条件项
    filterList: {
      type: Array,
      require: true,
      default: () => []
    },
    // 下拉框选项数据
    optionsData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      FormTypes,
      layoutConfig: {
        // 每个查询条件间隔
        gutter: 24,
        // 每个查询条件所占份数
        span: 6,
        // label布局
        labelCol: {
          span: 4
        },
        // 输入组件布局
        wrapperCol: {
          span: 18,
          offset: 1
        },
        // 多选下拉框默认最大显示个数
        maxTagCount: 3,
        // 折叠数
        foldCount: 3
      },
      // 预设时间范围
      ranges: {
        '今日': [moment(), moment()],
        '本月': [moment(), moment().endOf('month')],
        '本周': [moment(), moment().endOf('week')]
      },
      // 查询条件是否折叠
      expand: false,
      form: this.$form.createForm(this, {
        onValuesChange: this.onValuesChange,
        onFieldsChange: this.onFieldsChange
      })
    }
  },
  computed: {
    // 表单项折叠数量配置
    count() {
      return this.expand? this.filterList.length: this.layoutConfig.foldCount
    }
  },
  created() {

  },
  methods: {
    moment,
    // 重置表单
    resetFields() {
      this.form.resetFields()
    },
    // 下拉框过滤方法
    filterOption(input, option) {
      return option.componentOptions.children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 表单值改变触发
    onFieldsChange(form, values) {
      let field = Object.keys(values)[ 0 ]
      let value = values[ field ].value
      this.$emit('formChange', { field, form, value })
    },
    // 时间范围表单值改变触发
    onRangesDateChange(momentArr, strArr, item) {
      if (!item.props.start || !item.props.end) return this.$message.warning('缺少【props】配置项')
      this.value[ item.props.start ] = strArr[ 0 ]
      this.value[ item.props.end ] = strArr[ 1 ]
    },
    // 日期时间表单值改变触发
    onDateChange(momentArr, strArr, item) {
      this.value[ item.key ] = strArr
    },
    // 设置placeholder
    setPlaceholder(item) {
      // todo 完善多语言情况
      return item.placeholder
    }
  }
}
</script>


